require('angular');
require('./am-date-picker.module.js');
require('./am-date-picker.constant.js');
require('./am-date-picker.tmpl.js');
require('./am-date-picker.dialog.js');
require('./am-date-picker.directive.js');
require('./am-date-picker.provider.js');


//////////////////
// WEBPACK FOOTER
// ./~/am-date-picker/dist/index.js
// module id = 356
// module chunks = 2